import { useRecoilValue } from 'recoil';
import { organizationAtom } from 'services/organization/atom';

/**
 * @description Hook to get non nullable organization from the Recoil store
 * @returns organization
 */
export const useOrganization = () => {
  const organization = useRecoilValue(organizationAtom);

  if (!organization) {
    throw new Error('Organization not found');
  }

  return organization;
};
